export default __webpack_public_path__ + "static/media/strasbourg18.965a6fe9.jpg";